define(
    'services/service.folders',[
        "providers/dataprovider",
        "services/eventbroker",
        "services/config",
        "services/BusyTracker"
    ],

    function(dataProvider, eventBroker, config, BusyTracker) {

        var busyTracker = new BusyTracker();

        function getFavouriteFolders() {
            return $.Deferred(function (deferred) {
                busyTracker.canProceed().done(function () {
                    
                    var promise = dataProvider.folders.getFavouriteFolders()
                        .done(function (data, statusCode) {
                            deferred.resolve(data, statusCode);
                        })
                        .fail(function (data, statusCode) {
                            deferred.reject(data, statusCode);
                        });

                    busyTracker.add(promise);

                });
            }).promise();
        }

        return {
            busyTracker : busyTracker,
            getFavouriteFolders : getFavouriteFolders,
            favouriteFolder : markFolder("favourite"),
            unfavouriteFolder: markFolder("unfavourite")
        };

        // #region Internal Methods

        function markFolder(action) {
            return function (folderId, name) {
                var promise = dataProvider.folders[action + "Folder"](folderId, name);
                busyTracker.add(promise);
                return promise;
            };
        }

        //#endregion
    }
);
